import Vue from 'vue';
import Router from 'vue-router';
import Landing from './views/Landing.vue';
import NotePage from './views/NotePage.vue';
import NoteList from './views/NoteList.vue';
import Auth from './views/Auth.vue';
import Invite from './views/Invite.vue';
import Logout from './views/Logout.vue';
import Help from './views/Help.vue';
import CreateSpace from './views/CreateSpace.vue';
import LinkPage from './views/LinkPage.vue';

import store from './store';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Landing,
      meta: {
        isPublic: true,
      },
      beforeEnter: async (to, from, next) => {
        if (store.state.loggedIn) {
          if (store.state.user.space) {
            next({
              name: 'note-space',
              params: { spaceid: store.state.user.space.id },
            });
          } else {
            next({
              name: 'personal-new',
            });
          }
        } else {
          next();
        }
      },
    },
    {
      path: '/__signin',
      name: 'signin',
      component: Auth,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/signin',
      name: 'invite',
      component: Invite,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/personal/new',
      name: 'personal-new',
      component: CreateSpace,
      props: {
        idType: 'ユーザーID',
        title: 'ユーザーIDを設定',
        description: '個人のユーザーIDを設定します',
      },
    },
    // {
    //   path: '/group/new',
    //   name: 'group-new',
    //   component: CreateSpace,
    //   props: {
    //     idType: 'グループID',
    //     title: 'グループを作成',
    //     description: 'チームやプロジェクトのグループを作成します (例: ...)',
    //   },
    // },
    {
      path: '/note/new',
      name: 'note-new',
      component: NotePage,
    },
    {
      path: '/note/:noteid',
      name: 'note-id',
      component: NotePage,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/:spaceid/',
      name: 'note-space',
      component: NoteList,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '*',
      name: 'not-found',
      redirect: '/',
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/:spaceid/*',
      name: 'note-bound',
      component: LinkPage,
      meta: {
        isPublic: true,
      },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('auth');
  if (to.matched.some((record) => !record.meta.isPublic)) {
    if (!store.state.loggedIn) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

// TODO: Fix https://github.com/vuejs/vue-router/issues/748#issuecomment-379299862
Vue.use(Router);

export default router;
